import React, { useEffect, useState, useReducer} from "react";
import {useDispatch, useSelector, shallowEqual} from "react-redux";
import { Button, Select, Grid, Modal, TextField, Typography, Badge, MenuItem } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import DateFnsUtils from "@date-io/date-fns";
import {
  DatePicker,
  MuiPickersUtilsProvider
} from "@material-ui/pickers";
import FormHelperText from "@material-ui/core/FormHelperText";
import {compose, graphql} from "react-apollo";
import Divider from "@material-ui/core/Divider";
import {NotificationManager} from "react-notifications";
import {AddCircleOutline} from "@material-ui/icons";
import format from 'date-fns/format'
import {primaryColor, webFont} from "../../config/theme";
import moment from "moment";
import {
  SelectedChefAvailability,
  updateCart,
  CreateInProgressBooking,
  setSelectedDate,
  setSelectedSlot,
  setPendingBooking,
  setBookingCompletedStep, setSelectedChefAndSlots
} from '../../redux/bookings';
import CartDish from "./CartDish";
import {CREATE_IN_PROGRESS_BOOKING} from "../../graphql/mutations/booking";
import {GET_CALENDAR_SLOTS} from "../../graphql/queries/schedule";
import {setScheduleMonth} from '../../redux/schedule';
import AddressComp from "./InProgress3";
import { parseAmountDecimal } from "../../utils/common-methods";
import style from "../TimeSlot/style";
import { client } from '../../config/apollo';

const defaultChefImg = "/images/simple-chef.webp";
const hours = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

class FrDateFnsUtils extends DateFnsUtils {
  startOfMonth(date) {
    return moment(date).startOf('month').toDate();
  }

  getDatePickerHeaderText(date) {
    return format(date, 'd MMMM', {locale: this.locale})
  }
}

const InProgress1 = (props) => {
  const dispatch = useDispatch();
  const {
    isChef, cart, diner, exBooking, inProgressBooking, pendingBooking,
    userId, selectedChef, selectedDateRedux, selectedSlot, selectedChefId,
    chefAvailability, scheduleMonth, showAddDish, selectedChefAndSlots
  } = useSelector(store => ({
    userId: store.auth.userId,
    isChef: store.auth.isChef,
    cart: store.bookings.cart,
    diner: store.user.diner,
    exBooking: store.bookings.exBooking,
    inProgressBooking: store.bookings.inProgressBooking,
    pendingBooking: store.bookings.pendingBooking,
    selectedChef: store.bookings.selectedChef,
    selectedDateRedux: store.bookings.selectedDate,
    selectedSlot: store.bookings.selectedSlot,
    selectedChefId: store.bookings.selectedChefId,
    chefAvailability: store.bookings.chefAvailability,
    scheduleMonth: store.schedule.scheduleMonth,
    showAddDish: store.bookings.showAddDish,
    bookingCompletedStep: store.bookings.bookingCompletedStep,
    selectedChefAndSlots: store.bookings.selectedChefAndSlots,
  }));

  const initialState = {
    availability: [],
    chef: '',
    cartDishes: [],
    cuisines: [],
    profilePic: null,
    pickerRef: false,
    pickerRef2: false,
    datePickerRef: false,
    selectedDate: props.selectedDate ? props.selectedDate : moment()
      .add(3, "hours")
      .format("YYYY-MM-DD"),
    minDate: moment().format("YYYY-MM-DD"),
    startTime: moment("09:00", "HH:mm"),
    endTime: moment("13:00", "HH:mm"),
    dishCount: 0,
    qtyError: "",
    totalAmount: 0,
    message: "",
    showAddress: false,
    scheduleMonth: Number(moment().format('MM')),
    booking: null,
    totalWithServiceCharge: 0,
    from: 'AM',
    fromTime: "09:00",
    fromHour: parseInt("09:00".split(":")[0]),
    fromMinutes: "09:00".split(":")[1],
    to: 'PM',
    toTime: "01:00",
    toHour: parseInt("01:00".split(":")[0]),
    toMinutes: "01:00".split(":")[1],
    chefAvailability: null,
    dynamicTimeUpdate: false,
    isRecurring: props.isRecurring || false,
    recurringDays: [],
    recurringCount: 1,
    monthlySlots: [],
    addDishClicked: false
  };

  const [state, setState] = useReducer((oldProps, newProps) => ({ ...oldProps, ...newProps }), initialState);

  const openPicker = e => { setState({pickerRef: !state.pickerRef}) };

  const handleMonthChange = date => {
    const updatedMonth = moment(date).format('MM');
    setState({ scheduleMonth: updatedMonth });
    dispatch(setScheduleMonth(updatedMonth));
  };

  const openDatePicker = e => { setState({datePickerRef: !state.datePickerRef}) };

  const showAddressToggle = () => { setState({ showAddress: !state.showAddress }) };

  const increaseDishQty = (dishId, qty) => {
    let dish = cart.find(o => o.id == dishId);
    let index = cart.indexOf(dish);
    cart[index].serves = qty + 1;
    dispatch(updateCart(cart));
    setState({dishCount: qty + 1, qtyError: ''});
  };

  const timeValidate = () => {
    let format = 'HH:mm';
    let startTime = moment(state.fromTime+' ' +state.from, ["h:mm A"],format);
    let endtime = moment(state.toTime+' ' +state.to, ["h:mm A"],format);
    let validTime = (endtime.isAfter(startTime) && startTime.isBefore(endtime));
    setState({ validTime });
  };

  const handelSelectFrom = value => {
    setState({ from: value, startTime: moment(`${state.fromTime} ${value}`, 'hh:mm A') },() => {

      dispatch(setSelectedSlot({
        start: state.startTime.format('hh:mm A'),
        end: state.endTime ? state.endTime.format('hh:mm A') : null
      }));
      timeValidate()
    });
  };

  const onFromTimeChange = (value) => {
    setState({ fromTime: value, startTime: moment(`${value} ${state.from}`, 'hh:mm A') },() => {
      dispatch(setSelectedSlot({
        start: state.startTime.format('hh:mm A'),
        end: state.endTime ? state.endTime.format('hh:mm A') : null
      }));
      timeValidate();
    });
  };

  const onToTimeChange = (value) => {
    setState({ toTime: value, endTime: moment(`${value} ${state.to}`, 'hh:mm A') },() => {
      dispatch(setSelectedSlot({
        start: state.startTime.format('hh:mm A'),
        end: state.endTime ? state.endTime.format('HH:mm') : null
      }));
      timeValidate();
    });
  };

  const handelSelectTo = value => {
    setState({ to: value, endTime: moment(`${state.toTime} ${value}`, 'hh:mm A') },() => {
      dispatch(setSelectedSlot({
        start: state.startTime.format('hh:mm A'),
        end: state.endTime ? state.endTime.format('hh:mm A') : null
      }));
      timeValidate();
    });
  };

  const decreaseDishQty = (dishId, qty) => {
    const {qtyError} = state;
    let dish = cart.find(o => o.id == dishId);
    let index = cart.indexOf(dish);
    if (cart[index].serves > cart[index].minDinerSize) {
      cart[index].serves = qty - 1;
    } else {
      const qtyErrMsg = cart[index].minDinerSize + ' is the minimum number of diners.';
      setState({qtyError: qtyErrMsg});
    }
    setState({dishCount: qty + 1});
  };

  const handleDateChange = d => {
    setState({
      selectedDate: new Date(d),
      addDishClicked: false
    });

    dispatch(SelectedChefAvailability(selectedChef.id, moment(d).format("YYYY-MM-DD")));
    dispatch(setSelectedDate(new Date(d)));
  };

  const handleStartTimeChange = d => {
    let {endTime} = state;
    const startTime = moment(d);
    setState({startTime});

    dispatch(SelectedChefAvailability(selectedChef.id, state.selectedDate));
    dispatch(setSelectedSlot({
      start: startTime.format('HH:mm'),
      end: endTime ? endTime.format('HH:mm') : null
    }));
  };

  const handleEndTimeChange = d => {
    let {startTime} = state;
    const endTime = moment(d);
    setState({endTime});

    dispatch(SelectedChefAvailability(selectedChef.id, state.selectedDate));
    dispatch(setSelectedSlot({
      start: startTime.format('HH:mm'),
      end: endTime.format('HH:mm')
    }));
  };

  const handleMessageChange = e => { setState({message: e.target.value}) };

  const isInSchedule = date => {
    const {
      monthlySlots: {getCalendarSlots}
    } = state;


    let isAvailable = false;

    if (getCalendarSlots)
      isAvailable = getCalendarSlots.find(day => {
        return day.date === moment(date).format("YYYY-MM-DD");
      });

    return !!isAvailable;
  };

  const addDishToBooking = () => {
    const {handleToggle} = props;
    dispatch(setPendingBooking(pendingBooking));
    handleToggle();
    setState({ addDishClicked: true });
    updateSelectedSlot();
  };

  const updateSelectedSlot = () => {
    const {
      startTime, endTime,
    } = state;

    const sTime = startTime.format('HH:mm');
    const eTime = moment.isMoment(endTime) ? endTime.format('HH:mm')
      : moment(endTime, 'hh:mm A').format('HH:mm');

    const payload = {
      start: sTime,
      end: eTime
    };

    dispatch(setSelectedChefAndSlots({ selectedSlot: payload, chefId: state.chef ? state.chef.id : selectedChef ? selectedChef.id : null }));
    dispatch(setSelectedSlot(payload));
  };

  const fetchMonthlySlots = () => {
    if (!state.chef && !state.scheduleMonth) return;

    client.query({
        query      : GET_CALENDAR_SLOTS,
        variables  : {
          chefId: state.chef.id,
          start : moment(state.scheduleMonth, 'MM')
            .startOf('month')
            .format('YYYY-MM-DD'),
          end   : moment(state.scheduleMonth, 'MM')
            .endOf('month')
            .format('YYYY-MM-DD')
        },
        fetchPolicy: 'network-only'
      })
      .then(response => {
        setState({ monthlySlots: response.data })
      })
      .catch(err => console.error('ERROR FETCHING SLOTS FOR THE GIVEN MONTH', state.scheduleMonth, err));
    dispatch(SelectedChefAvailability(state.chef.id, state.selectedDate));
  };

  const renderWrappedWeekDay = (date, selectedDate, dayInCurrentMonth, dayComponent) => {
    let inDate = moment(date);
    const inCompDate = inDate.format("YYYY") + "-" + inDate.format("MM") + "-" + inDate.format("DD");
    inDate = moment(inCompDate);
    let today = moment(new Date());
    const compToday = today.format("YYYY") + "-" + today.format("MM") + "-" + today.format("DD");
    today = moment(compToday);

    if (inDate.isBefore(today)) {
      return <Badge>{dayComponent}</Badge>;
    }
    else {
      return <Badge badgeContent={<span
        style={{
          fontSize: 30,
          fontWeight: 500,
          color: isInSchedule(date) ? "green" : "white"
        }}
      >
                .
                </span>}>{dayComponent}</Badge>;
    }
  };

  const handleNextSubmit = () => {
    let dishes = [];
    const {city} = diner.address ? diner.address : {};

    cart.map(dish => {
      let bookingDish = {
        dishId: dish.id,
        serves: dish.serves
      };
      dishes.push(bookingDish);
    });

    if (!state.startTime || !state.endTime) {
      NotificationManager.error('Please choose the start and end time', 'Booking')
      return;
    }

    let startTime = state.startTime;

    let endTime = state.endTime;
    if (typeof endTime === 'string') {
      endTime = moment(endTime, 'hh:mm A');
    }

    if (selectedSlot) {
      if (selectedSlot.start && selectedSlot.end) {
        startTime = moment(selectedSlot.start, 'HH:mm');
        endTime = moment(selectedSlot.end, 'HH:mm')
      }
    }

    let payload = {
      userId: userId,
      chefId: selectedChefId || selectedChef.id,
      date: state.selectedDate,
      distance: "10",
      timeSlot: {
        start: startTime.format("HH:mm"),
        end: endTime.format("HH:mm")
      },
      dishes: dishes,
      message: state.message
    };

    let format = 'HH:mm';
    let chefAvail = false;

    if (typeof chefAvailability === "object" && chefAvailability && !!chefAvailability.length && chefAvailability.length > 0) {
      let startTime = moment(state.startTime, format);
      let endTime = moment(state.endTime, 'hh:mm A');
      chefAvailability.forEach(availableSlot => {

        let beforeTime = moment(availableSlot.start, format),
          afterTime = moment(availableSlot.end, format).add(1, 'minute');

        if ((startTime.isBetween(beforeTime, afterTime) || startTime.isSameOrAfter(beforeTime)) && (endTime.isSameOrBefore(afterTime) || endTime.isBetween(beforeTime, afterTime)) && startTime.isBefore(endTime)) {
          chefAvail = true;
        }
      });
    }

    if (!!city) {
      if (chefAvail) {
        client.mutate({
          mutation: CREATE_IN_PROGRESS_BOOKING,
          variables: {
            booking: payload
          }
        })
          .then(res => {
            dispatch(CreateInProgressBooking(res.data.createInProgressBooking));
            dispatch(setSelectedChefAndSlots({ selectedSlot: payload.timeSlot, chefId: payload.chefId }));
            props.changeProgressStep(2);
            dispatch(setPendingBooking({
              ...payload,
              id: res.data.createInProgressBooking,
            }));

            dispatch(setSelectedSlot({
              start: startTime.format('HH:mm'),
              end: endTime.format('HH:mm')
            } ));
            dispatch(setBookingCompletedStep(1));
          })
          .catch(err => {
            console.log(JSON.parse(JSON.stringify(err)));
            let errorObj = JSON.parse(JSON.stringify(err));
            if (errorObj.graphQLErrors) {
              errorObj.graphQLErrors.forEach(error => {
                if (error.message.startsWith('Cannot make booking')) {
                  NotificationManager.error('Please select a booking date and time that is at least 1 hour away to allow for the Chef to prepare for your booking.', 'Unable to book')
                } else if (error.message.includes('Your account cannot')) {
                  NotificationManager.error('Chef has not completed the registration process.', 'Unable to book')
                } else {
                  NotificationManager.error(error.message, "Booking");
                }
              });
            }

          });
      } else {
        NotificationManager.error("Chef is not available ");
      }
    }
    else {
      NotificationManager.error("Please update your address.");
      setState({ showAddress: true });
    }
  };

  useEffect(() => {
    if (selectedChef) {
      let cuisines = '';
      setState({ chef: selectedChef, scheduleMonth: parseInt(moment().format('MM')) })
      if (selectedChef.cuisines) {
        if (selectedChef.cuisines.length) {
          if (selectedChef.cuisines.length < 3) {
            cuisines = selectedChef.cuisines.join(', ');
          } else {
            cuisines = 'Multi Cuisines';
          }
        }
      }

      const profilePic = selectedChef.profilePic;
      setState({ chef: selectedChef, cuisines, profilePic })
    }
  }, [selectedChef]);

  useEffect(() => {
    if (state.chef && state.scheduleMonth) {
      fetchMonthlySlots();
    }
  }, [state.chef, state.scheduleMonth])

  useEffect(() => {
    let totalAmount = 0;
    const cartDishes = cart.map(dish => {
      let pricePerQty = parseFloat((dish.minPrice / dish.minDinerSize).toFixed(2));
      totalAmount += Math.round(pricePerQty * dish.serves);
      return (
        <CartDish
          key={dish.id + "ren"}
          dish={dish}
          increaseDishQty={increaseDishQty}
          decreaseDishQty={decreaseDishQty}
        />
      );
    });

    setState({ cartDishes, totalAmount });
  }, [cart, ...cart.map(item=> item.serves)]);

  useEffect(() => {
    const totalWithServiceCharge = parseFloat((state.totalAmount).toFixed(2)) + parseFloat((state.totalAmount * 0.05).toFixed(2));
    setState({totalWithServiceCharge});
  }, [state.totalAmount]);

  useEffect(() => {
    if (selectedDateRedux) {
      setState({ selectedDate: moment(selectedDateRedux).format("YYYY-MM-DD") });
    }
  }, [selectedDateRedux]);

  useEffect(() => {
    if (chefAvailability && Array.isArray(chefAvailability)) {
      if (chefAvailability.length) {
        let availability = chefAvailability[0];

        if (availability.start) {
          let min = '00';
          const startMin = parseInt(availability.start.split(':')[1]);
          if (startMin <= 0 || startMin > 45) {
            availability.start = availability.start.split(':')[0] + ':' + '00';
          }
          if (startMin === 15) {
            availability.start = availability.start.split(':')[0] + ':' + '15';
          }
          if (startMin === 30) {
            availability.start = availability.start.split(':')[0] + ':' + '30';
          }
          if (startMin === 45) {
            availability.start = availability.start.split(':')[0] + ':' + '45';
          }
          if (startMin > 0 && startMin < 15) {
            availability.start = availability.start.split(':')[0] + ':' + '15';
          }
          if (startMin >15 && startMin < 30) {
            availability.start = availability.start.split(':')[0] + ':' + '30';
          }
          if (startMin > 30 && startMin < 45) {
            availability.start = availability.start.split(':')[0] + ':' + '45';
          }
        }

        if (availability.end) {
          let min = '00';
          const startMin = parseInt(availability.end.split(':')[1]);
          if (startMin <= 0 || startMin > 45) {
            availability.end = availability.end.split(':')[0] + ':' + '00';
          }
          if (startMin === 15) {
            availability.end = availability.end.split(':')[0] + ':' + '15';
          }
          if (startMin === 30) {
            availability.end = availability.end.split(':')[0] + ':' + '30';
          }
          if (startMin === 45) {
            availability.end = availability.end.split(':')[0] + ':' + '45';
          }
          if (startMin > 0 && startMin < 15) {
            availability.end = availability.end.split(':')[0] + ':' + '00';
          }
          if (startMin >15 && startMin < 30) {
            availability.end = availability.end.split(':')[0] + ':' + '15';
          }
          if (startMin > 30 && startMin < 45) {
            availability.end = availability.end.split(':')[0] + ':' + '30';
          }
        }

        setState({
          availability: chefAvailability.map(item => {
            const start = moment(item.start, 'HH:mm').format('hh:mm A');
            const end = moment(item.end, 'HH:mm').format('hh:mm A');
            const time = start + ' - ' + end;

            return time;
          }),
        });

        if (!state.addDishClicked && !selectedChefAndSlots) {
          setState({
            from: moment(availability.start, 'HH:mm').format('A'),
            fromTime: availability.start,
            fromHour: parseInt(moment(availability.start, 'HH:mm').format('hh')),
            fromMinutes: moment(availability.start, 'HH:mm').format('mm'),
            to: moment(availability.end, 'HH:mm').format('A'),
            toTime: availability.end,
            toHour: parseInt(moment(availability.end, 'HH:mm').format('hh')),
            toMinutes: moment(availability.end, 'HH:mm').format('mm'),
            startTime: moment(availability.start, 'HH:mm'),
            endTime: moment(availability.end, 'HH:mm')
          });
        }
      }
    }
  }, [chefAvailability]);

  useEffect(() => {

    if (selectedSlot) {
      if (selectedSlot.start && selectedSlot.end && inProgressBooking) {
        setState({
          from: moment(selectedSlot.start, 'HH:mm').format('A'),
          fromTime: selectedSlot.start,
          fromHour: parseInt(moment(selectedSlot.start, 'HH:mm').format('hh')),
          fromMinutes: moment(selectedSlot.start, 'HH:mm').format('mm'),
          to: moment(selectedSlot.end, 'HH:mm').format('A'),
          toTime: selectedSlot.end,
          toHour: parseInt(moment(selectedSlot.end, 'HH:mm').format('hh')),
          toMinutes: moment(selectedSlot.end, 'HH:mm').format('mm'),
        });
      }
    }
  }, [selectedSlot])

  /*useEffect(() => {
    console.log('UPDATE CALLED FROM USE EFFECT');
    updateSelectedSlot();
  }, [state.startTime, state.endTime]);*/

  useEffect(() => {
    if (selectedChefAndSlots) {
      if (selectedChefAndSlots.selectedSlot) {
        if (selectedChefAndSlots.selectedSlot.start && selectedChefAndSlots.selectedSlot.end) {
          const startTimeStr = selectedChefAndSlots.selectedSlot.start;
          const endTimeStr = selectedChefAndSlots.selectedSlot.end;

          const startTime = moment(startTimeStr, 'HH:mm');
          const endTime = moment(endTimeStr, 'HH:mm');
          const from = startTime.format('A');
          const to = endTime.format('A');
          const fromTime = startTime.format('hh:mm');
          const toTime = endTime.format('hh:mm');
          const fromHour = parseInt(startTime.format('hh'));
          const toHour = parseInt(endTime.format('hh'));
          const fromMinutes = startTime.format('mm');
          const toMinutes = endTime.format('mm');

          setState({ startTime, endTime, from, fromTime, fromHour, to, toTime, toHour, fromMinutes, toMinutes });
        }
      }
    }
  }, [selectedChefAndSlots]);

  return (
    <div>
      <Grid container>
        <Grid item xs={12}>
          <Typography
            style={{
              ...styles.setFont,
              fontSize: 24,
              fontWeight: 500,
              marginBottom: 30,
              color: '#000000'
            }}
          >
            Review your booking
          </Typography>
        </Grid>

        <Grid item xs={12}>
          {!!selectedChef && (
            <Grid container justify={'space-between'}>
              <Grid item xs={2} sm={2}>
                <img
                  src={state.profilePic ? state.profilePic : defaultChefImg}
                  style={styles.chefImg}
                  alt={"Chef Name"}
                />

              </Grid>
              <Grid data-test-id={"bkgonechefname"}  item xs={8} justify={'flex-start'}>
                <Typography
                  style={{...styles.setFont, fontSize: 15, fontWeight: 400}}
                >
                  {`${selectedChef.firstName.toUpperCase()} ${selectedChef.lastName.toUpperCase()}`}
                </Typography>
                <Typography>{state.cuisines}</Typography>
              </Grid>

              <Grid data-test-id={"bkgoneamt"} item xs={2}>
                <Typography
                  style={{
                    ...styles.setFont,
                    fontSize: 20,
                    color: primaryColor,
                    textAlign: 'right'
                  }}
                >
                  ${parseAmountDecimal(state.totalWithServiceCharge)}
                </Typography>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>

      <Grid container style={{marginTop: 25}}>
        <Grid item xs={8}>
          <Typography
            style={{
              ...styles.setFont,
              fontSize: 18,
              fontWeight: 500,
              marginBottom: 20
            }}
          >
            Date
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Grid   data-test-id={"bkgonedatepicker"} item alignContent={"flex-end"} alignItems={"flex-end"}>
            <MuiPickersUtilsProvider utils={FrDateFnsUtils}>
              <DatePicker
                style={{...styles.setFont, color: primaryColor, display: "none",}}
                value={state.selectedDate}
                animateYearScrolling
                // autoOk={true}
                onChange={handleDateChange}
                onMonthChange={handleMonthChange}
                onAccept={(d) => {openDatePicker()}}
                onClose={() => {openDatePicker()}}
                minDate={moment.isMoment(state.minDate) ? state.minDate.toDate() : moment(state.minDate, 'YYYY-MM-DD').toDate()}
                open={state.datePickerRef}
                renderDay={renderWrappedWeekDay}
              />

              <Typography
                align={"right"}
                style={{ ...styles.setFont, fontSize: 18, color: primaryColor, marginLeft: -5 }}
                onClick={openDatePicker}
              >
                {moment(state.selectedDate).format("DD MMM YYYY")}
              </Typography>

            </MuiPickersUtilsProvider>
          </Grid>
        </Grid> <Divider variant="inset" style={{margin: 'auto', width: "100%"}}/>
      </Grid>

      <Grid container style={{marginTop: 25}}>
        <Grid item xs={4}>
          <Typography
            style={{
              ...styles.setFont,
              fontSize: 18,
              fontWeight: 500,
              marginBottom: 20
            }}
          >
            Time
          </Typography>
        </Grid>

        <Grid item md={8} sm={8} xs={12}>
          <Grid container>
            <Grid item md={12} sm={8} xs={12}>
              <p style={{ ...style.labelText, marginLeft: 100}}>FROM</p>
            </Grid>
            <Grid item md={12} sm={12} xs={8} style={{display: 'flex', justifyContent: 'flex-end'}}>
              <Select
                inputProps={{MenuProps: {disableScrollLock: true}}}
                className="select-option"
                data-test-id={"fromhour-id"}
                value={state.fromHour}
                onChange={evt => {
                  setState({
                    fromHour: evt.target.value,
                    fromTime: `${evt.target.value}:${state.fromMinutes}`,
                    startTime: moment(`${evt.target.value}:${state.fromMinutes} ${state.from}`, 'HH:mm')
                  });
                  // updateSelectedSlot();
                }}
                style={style.inputText}
              >
                {
                  hours.map(hour => (
                    <MenuItem value={hour} key={hour} style={style.inputText}>
                      {hour < 10 ? `0${hour}` : hour}
                    </MenuItem>
                  ))
                }
              </Select>
              <Select
                inputProps={{MenuProps: {disableScrollLock: true}}}
                className="select-option"
                data-test-id={"fromminute-id"}
                value={state.fromMinutes}
                onChange={evt => {
                  setState({
                    fromMinutes: evt.target.value,
                    fromTime: `${state.fromHour}:${evt.target.value}`,
                    startTime: moment(`${state.fromHour}:${evt.target.value} ${state.from}`, 'hh:mm A')
                  }); // updateSelectedSlot();
                }}
                style={{marginLeft:'24px', ...style.inputText}}
              >
                <MenuItem value={"00"} style={style.inputText}>
                  00
                </MenuItem>
                <MenuItem value={"15"} style={style.inputText}>
                  15
                </MenuItem>
                <MenuItem value={"30"} style={style.inputText}>
                  30
                </MenuItem>
                <MenuItem value={"45"} style={style.inputText}>
                  45
                </MenuItem>
              </Select>
              <Select
                inputProps={{MenuProps: {disableScrollLock: true}}}
                className="select-option"
                data-test-id={"frommenu-id"}
                value={state.from}
                onChange={evt => handelSelectFrom(evt.target.value)}
                style={{marginLeft:'24px'}}
              >
                <MenuItem value={"AM"} style={style.inputText}>
                  AM
                </MenuItem>
                <MenuItem value={"PM"} style={style.inputText}>
                  PM
                </MenuItem>
              </Select>
            </Grid>

            <Grid item md={12} sm={12} xs={12} style={{marginTop:24}}>
              <p style={{ ...style.labelText, marginLeft: 100 }}>TO</p>
            </Grid>

            <Grid item md={12} sm={12} xs={8} style={{display: 'flex', justifyContent: 'flex-end'}}>
              <Select
                inputProps={{MenuProps: {disableScrollLock: true}}}
                className="select-option"
                data-test-id={"tohour-id"}
                value={state.toHour}
                onChange={evt => {
                  setState({
                    toHour: evt.target.value,
                    toTime: `${evt.target.value}:${state.toMinutes}`,
                    endTime: moment(`${evt.target.value}:${state.toMinutes} ${state.to}`, 'hh:mm A')
                  }); // updateSelectedSlot();
                }}
                style={style.inputText}
              >
                {
                  hours.map(hour => (
                    <MenuItem value={hour} key={hour} style={style.inputText}>
                      {hour < 10 ? `0${hour}` : hour}
                    </MenuItem>
                  ))
                }
              </Select>
              <Select
                inputProps={{MenuProps: {disableScrollLock: true}}}
                className="select-option"
                data-test-id={"tominute-id"}
                value={state.toMinutes}
                onChange={evt => {
                  setState({
                    toMinutes: evt.target.value,
                    toTime: `${state.toHour}:${evt.target.value}`,
                    endTime: `${state.toHour}:${evt.target.value} ${state.to}`
                  }); // updateSelectedSlot();
                }}
                style={{marginLeft:'24px', ...style.inputText}}
              >
                <MenuItem value={"00"} style={style.inputText}>
                  00
                </MenuItem>
                <MenuItem value={"15"} style={style.inputText}>
                  15
                </MenuItem>
                <MenuItem value={"30"} style={style.inputText}>
                  30
                </MenuItem>
                <MenuItem value={"45"} style={style.inputText}>
                  45
                </MenuItem>
              </Select>
              <Select
                inputProps={{MenuProps: {disableScrollLock: true}}}
                className="select-option"
                data-test-id={"tomenu-id"}
                value={state.to}
                onChange={evt => handelSelectTo(evt.target.value)}
                style={{marginLeft:'24px'}}
              >
                <MenuItem value={"AM"} style={style.inputText}>
                  AM
                </MenuItem>
                <MenuItem value={"PM"} style={style.inputText}>
                  PM
                </MenuItem>
              </Select>
            </Grid>
          </Grid>
        </Grid>

        <Divider variant="inset" style={{margin: 'auto', width: "100%", marginTop: 25}}/>
      </Grid>

      <Grid container>
        <Grid item xs={12} style={{marginTop: 10}}>
          <div style={{marginTop: 10, marginBottom: 20}}>
            {typeof chefAvailability === "object" && chefAvailability ? `Chef Availability: ${state.availability.join(" , ")}` : (
              <FormHelperText id="component-error-text" style={styles.error}>
                {chefAvailability}{" "}
              </FormHelperText>
            )}
          </div>
        </Grid>
      </Grid>

      <Grid>
        <Grid container>
          <Grid item xs={7}>
            <Typography style={{...styles.setFont, fontSize: 18, fontWeight: 500}}>
              Dishes
            </Typography>
          </Grid>
          <Grid item xs={5}>
            <Grid container alignItems={'center'}>
              <Grid item xs={4}/>
              <Grid item xs={5}>
                {showAddDish && <Typography style={{...styles.setFont, fontSize: 15, fontWeight: 500}}>
                  Add Dish
                </Typography>}
              </Grid>
              <Grid item xs={2}>
                {showAddDish && <AddCircleOutline
                  data-test-id={"adddish-step1"}
                  onClick={addDishToBooking}
                  style={{
                    ...styles.setFont, ...styles.setColor, ...styles.setRoundedIcon,
                    fontSize: 26, float: "left", marginTop: 3, marginRight: 5
                  }}
                />}

              </Grid>
              <Grid item xs={1}/>
            </Grid>
          </Grid>
        </Grid>
        <div
          style={{
            padding: 10,
            marginTop: 10,
            opacity: 0.62,
            borderRadius: 2,
            borderWidth: 1,
            borderColor: "#979797",
            borderStyle: "solid",
          }}
        >
          {state.cartDishes}
          <FormHelperText id="component-error-text" style={styles.error}>
            {state.qtyError}
          </FormHelperText>
        </div>
      </Grid>

      <Grid style={{
        paddingLeft: 10,
        marginTop: 15,
        marginBottom: 20
      }}>

        <Grid container>
          <Grid item xs={10}>
            Dishes total
          </Grid>
          <Grid item xs={2}>
            ${state.totalAmount.toFixed(2)}
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={10}>
            Service charges (5%)
          </Grid>
          <Grid item xs={2}>
            ${(state.totalAmount * 0.05).toFixed(2)}
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={10}>
            Total amount
          </Grid>
          <Grid item xs={2}>
            ${state.totalWithServiceCharge.toFixed(2)}
          </Grid>
        </Grid>

      </Grid>

      <Grid>
        <Typography
          style={{...styles.setFont, fontSize: 18, fontWeight: 500, marginTop: 10}}
        >
          Message
        </Typography>

        <TextField
          inputProps={{ 'data-test-id': 'bkgonemsg' }}
          fullWidth
          id="outlined-with-placeholder"
          multiline={true}
          rows="3"
          placeholder="Tell chef about the nature and purpose of the engagement"
          margin="normal"
          variant={'outlined'}
          onChange={handleMessageChange}
        />
      </Grid>
      <Grid container style={{marginTop: 40, marginBottom: 10, alignItems: 'center'}} justify="center" direction="column">
        <Grid item>
          <Button
            data-test-id={"bkgonenext"}
            style={{...styles.setFont, ...styles.nextBtn}}
            onClick={handleNextSubmit}
          >
            Next
          </Button>
        </Grid>

        <Modal
          disableEscapeKeyDown={true}
          onClose={() => {}}
          open={state.showAddress}
          aria-labelledby={"address-dialog"}
          className="custom-address-step3">
          <Grid style={{ padding: '20px 30px', maxWidth: 500, backgroundColor: '#fff', margin: '60px auto', maxHeight: '80vh', overflow: 'scroll' }}>
            <div className="close-icon-address-step3" onClick={() => setState({ showAddress: false })}>
              <Close />
            </div>
            <AddressComp stepOne={true} closeModal={showAddressToggle} />
          </Grid>
        </Modal>
      </Grid>

    </div>
  );
};

export default InProgress1;

const styles = {
  setFont: {
    fontFamily: webFont
  },
  error: {fontSize: 12, color: "red", fontFamily: webFont},
  chefImg: {
    width: 60,
    height: 60,
    // objectFit: "contain",
    borderRadius: "50%"
  },
  nextBtn: {
    minWidth: 240,
    height:48,
    textAlign: "center",
    borderRadius: 24,
    backgroundColor: primaryColor,
    color: "#fff",
    textTransform: 'none',
    fontWeight: 'normal',
    fontSize: 18,
  },
  setColor: {
    color: primaryColor
  },
  setRoundedIcon: {
    borderRadius: "50%",
    borderColor: primaryColor
  },
  updateBtn: {
    minWidth: 240,
    height:48,
    textAlign: "center",
    borderRadius: 24,
    borderColor: primaryColor,
    borderWidth: 1,
    color: primaryColor,
    backgroundColor: "#fff",
    textTransform: 'none',
    fontSize: 18,
    fontWeight: 'normal',
    marginTop: 5
  }
};
